import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import { restoreAll } from '../restoreAll';

export interface LoaderState {
    [key: string]: string[];
}

interface ILoaderAction {
    key: string;
    value: string;
}

const initialState: LoaderState = {};

export const loader = createSlice({
    name: 'loader',
    initialState,
    extraReducers: builder => builder.addCase(restoreAll, () => initialState),
    reducers: {
        push: (state, action: PayloadAction<ILoaderAction>) => {
            const { key, value } = action.payload;
            const loaderValues = state[key] || [];
            if (loaderValues.indexOf(value) !== -1) {
                return;
            }
            loaderValues.push(value);
            state[key] = loaderValues;
        },
        pop: (state, action: PayloadAction<ILoaderAction>) => {
            const { key, value } = action.payload;
            const loaderValues = state[key] || [];
            const newLoaderValues = loaderValues.filter((el: any) => el !== value);
            state[key] = newLoaderValues;
        },
    },
});

export const loaderAction = loader.actions;
export default loader.reducer;
